import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { UserPreferenceActions } from '../actions/user-preference.actions';
import { UserPreferenceSelectors } from '../selectors/user-preference.selector';
import { Observable, of } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { RedeliveryUserPreferenceComponentNameType, UserPreferenceComponentNameType, UserPreferenceResultType } from '@shared/types/user-preference.types';
import { UserPreferenceModel } from '@shared/models/shared/user-preference.model';

export interface ReleaseNotes {
  InbondLayout: string;
}

@Injectable()
export class UserPreferenceHandlerService {
  inbondLayoutPreferencesSelector$ = this.store$.pipe(select(UserPreferenceSelectors.inbondLayoutPreferences));
  inbondLayoutPreferencesSuccess$ = this.actions$.pipe(
    ofType(UserPreferenceActions.getInbondLayoutPreferenceSuccess),
    map((action) => action.preferences)
  );
  inbondLayoutPreferencesFail$ = this.actions$.pipe(
    ofType(UserPreferenceActions.getInbondLayoutPreferenceFail),
    map((action) => action.errors)
  );

  updateInbondLayoutPreferencesSuccess$ = this.actions$.pipe(
    ofType(UserPreferenceActions.updateInbondLayoutPreferenceSuccess),
    map((action) => action.preferences)
  );
  updateInbondLayoutPreferencesFail$ = this.actions$.pipe(
    ofType(UserPreferenceActions.updateInbondLayoutPreferenceFail),
    map((action) => action.errors)
  );

  redeliveryLayoutPreferencesSelector$ = this.store$.pipe(select(UserPreferenceSelectors.redeliveryLayoutPreferences));
  redeliveryLayoutPreferencesSuccess$ = this.actions$.pipe(
    ofType(UserPreferenceActions.getRedeliveryLayoutPreferenceSuccess),
    map((action) => action.preferences)
  );
  redeliveryLayoutPreferencesFail$ = this.actions$.pipe(
    ofType(UserPreferenceActions.getRedeliveryLayoutPreferenceFail),
    map((action) => action.errors)
  );

  updateRedeliveryLayoutPreferencesSuccess$ = this.actions$.pipe(
    ofType(UserPreferenceActions.updateRedeliveryLayoutPreferenceSuccess),
    map((action) => action.preferences)
  );
  updateRedeliveryLayoutPreferencesFail$ = this.actions$.pipe(
    ofType(UserPreferenceActions.updateRedeliveryLayoutPreferenceFail),
    map((action) => action.errors)
  );

  constructor(public store$: Store, public actions$: Actions) {}

  getInbondLayoutPreference(componentName: UserPreferenceComponentNameType): void {
    this.store$.dispatch(UserPreferenceActions.getInbondLayoutPreference({ componentName }));
  }

  updateInbondLayoutPreference(componentName: UserPreferenceComponentNameType, preferences: UserPreferenceResultType): void {
    this.store$.dispatch(UserPreferenceActions.updateInbondLayoutPreference({ componentName, preferences }));
  }

  getRedeliveryLayoutPreference(componentName: RedeliveryUserPreferenceComponentNameType): void {
    this.store$.dispatch(UserPreferenceActions.getRedeliveryLayoutPreference({ componentName }));
  }

  updateRedeliveryLayoutPreference(componentName: RedeliveryUserPreferenceComponentNameType, preferences: UserPreferenceResultType): void {
    this.store$.dispatch(UserPreferenceActions.updateRedeliveryLayoutPreference({ componentName, preferences }));
  }
}